import AgentHubEarnYourOwnTourModal from 'agentHub/components/AgentHubEarnYourOwnTourModal'
import { canShowAgentHubEarnYourOwnTourModal } from 'agentHub/onboarding/canStartAgentHubBookingOnboarding'
import { useAgentHubBookingOnboardingStatus } from 'agentHub/onboarding/useAgentHubBookingOnboarding'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { isAgentHubEarnYourOwnTourModalDismissed } from 'agentHub/storage/agentHubEarnYourOwnTourModalStorage'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { haveOrdersBeenFetched } from 'lib/order/orderUtils'
import { useContext, useEffect, useRef, useState } from 'react'
import { selectLoggedIn } from 'selectors/accountSelectors'

function useAgentHubEarnYourOwnTourLoginModal() {
  const showModal = useContext(ModalContext)
  const loggedIn = useAppSelector(selectLoggedIn)
  const initComplete = useAppSelector(state => state.auth.initComplete)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const isSpoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const hasOrders = useAppSelector(state => Object.keys(state.orders?.orders ?? {}).length > 0)
  const ordersHaveBeenFetched = useAppSelector(state => haveOrdersBeenFetched(state, 'upcoming'))
  const hasShown = useRef(false)
  const [canShowAfterLogin, setCanShowAfterLogin] = useState(false)
  const storedOnboardingStatus = useAgentHubBookingOnboardingStatus()

  useEffect(() => {
    // Only arm once auth bootstrap has settled. A silent OIDC session restore
    // flips loggedIn from false to true while initComplete is still false, and
    // that rehydration must not be treated as a fresh login that shows the promo.
    if (!loggedIn && initComplete) {
      setCanShowAfterLogin(true)
    }
  }, [loggedIn, initComplete])

  useEffect(() => {
    if (!isAgentHubEnabled) return
    if (!loggedIn) return
    if (!canShowAfterLogin) return
    if (hasShown.current) return
    if (isAgentHubEarnYourOwnTourModalDismissed()) return
    if (!canShowAgentHubEarnYourOwnTourModal({
      hasOrders,
      haveOrdersBeenFetched: ordersHaveBeenFetched,
      isAgentHubEnabled,
      isLoggedIn: loggedIn,
      isSpoofed,
      memberId,
      storedStatus: storedOnboardingStatus,
    })) return

    hasShown.current = true
    showModal(<AgentHubEarnYourOwnTourModal />)
  }, [
    canShowAfterLogin,
    hasOrders,
    isSpoofed,
    loggedIn,
    memberId,
    ordersHaveBeenFetched,
    showModal,
    storedOnboardingStatus,
  ])
}

export default useAgentHubEarnYourOwnTourLoginModal
